import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { ImageBlockUploader } from "./ImageBlockUploader";
import { inputSx } from "../blogTheme";
const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: "#065F46" },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { bgcolor: "#065F46" },
};

export function SeoMetaForm({ values = {}, onChange }) {
  const field = (name) => ({
    value: values[name] || "",
    onChange: (e) => onChange(name, e.target.value),
    size: "small",
    fullWidth: true,
    sx: inputSx,
  });

  const titleLen = (values.metaTitle || "").length;
  const descLen = (values.metaDescription || "").length;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextField
          {...field("metaTitle")}
          label="Meta Title"
          helperText={
            <Typography component="span" variant="caption" color={titleLen > 70 ? "error" : "text.secondary"}>
              {titleLen}/70
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("canonicalUrl")} label="Canonical URL" />
      </Grid>
      <Grid item xs={12}>
        <TextField
          {...field("metaDescription")}
          label="Meta Description"
          multiline
          rows={3}
          helperText={
            <Typography component="span" variant="caption" color={descLen > 160 ? "error" : "text.secondary"}>
              {descLen}/160
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("focusKeyword")} label="Focus Keyword" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={values.keywords || []}
          onChange={(_, val) => onChange("keywords", val)}
          renderInput={(params) => <TextField {...params} label="Keywords" size="small" sx={inputSx} />}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("ogTitle")} label="OG Title" />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("ogDescription")} label="OG Description" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Box>
          <Typography variant="caption" color="text.secondary">OG Image</Typography>
          <ImageBlockUploader
            label="Upload OG Image"
            existingUrl={values.ogImage}
            onUpload={(url) => onChange("ogImage", url)}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          {...field("twitterCard")}
          label="Twitter Card"
          select
        >
          <MenuItem value="summary">Summary</MenuItem>
          <MenuItem value="summary_large_image">Summary Large Image</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("twitterTitle")} label="Twitter Title" />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("twitterDescription")} label="Twitter Description" />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField {...field("twitterCreator")} label="Twitter Creator" />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Switch
              checked={!!values.noIndex}
              onChange={(e) => onChange("noIndex", e.target.checked)}
              sx={switchSx}
            />
          }
          label="No Index"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Switch
              checked={!!values.noFollow}
              onChange={(e) => onChange("noFollow", e.target.checked)}
              sx={switchSx}
            />
          }
          label="No Follow"
        />
      </Grid>
    </Grid>
  );
}
